import { render } from "./ControleParametrizacoes.vue?vue&type=template&id=2042b3e6&scoped=true"
import script from "./ControleParametrizacoes.vue?vue&type=script&lang=js"
export * from "./ControleParametrizacoes.vue?vue&type=script&lang=js"

import "./ControleParametrizacoes.vue?vue&type=style&index=0&id=2042b3e6&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2042b3e6"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QLinearProgress,QTable,QTr,QTh,QTd});
